import { cn } from "@/utils/cn";

interface LogoIconProps {
  className?: string;
  logoColor?: "black" | "white";
}

const imageMap = {
  black: "./assets/images/NutriCoach-Logo-Black.svg",
  white: "./assets/images/NutriCoach-Logo-White.svg",
};

export const LogoIcon = ({ className, logoColor = "black" }: LogoIconProps) => {
  return <img src={imageMap[logoColor]} alt="NutriCoach Logo" className={cn(className)} />;
};
